import { UserRole } from '@domain/schemas/user-role';
import type { FetchUserAttributesOutput } from 'aws-amplify/auth';

/**
 * Used in FE
 * @param amplifyUser
 * @returns
 */
export const cognitoUserAttributes = (userAttributes: FetchUserAttributesOutput) => {
  return {
    given_name: userAttributes?.given_name ?? '',
    family_name: userAttributes?.family_name ?? '',
    email: userAttributes?.email,
    sub: userAttributes?.sub,
    'custom:tenant_id': userAttributes?.['custom:tenant_id'],
    'custom:teams': userAttributes?.['custom:teams'],
    'custom:role': userAttributes?.['custom:role'] || UserRole.User,
  };
};
